import type { RouteRecordRaw } from 'vue-router';

export const completedStudiesRoute: RouteRecordRaw = {
  path: '/completed-studies',
  name: 'CompletedStudies',
  component: () => import('./pages/CompletedStudiesPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:students:list'),
  },
};
